import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DEFAULT_PAGING_CONFIG } from 'src/constants/paging-config';
import { HttpClient } from '@angular/common/http';
import { ApiGlobalSearchResponse } from 'src/app/shared/models/global-search/ApiGlobalSearchResponse';
import { map } from 'rxjs/operators';
import { GlobalSearchResults } from 'src/app/shared/models/global-search/GlobalSearchResults';
import { GlobalSearchResult } from 'src/app/shared/models/global-search/GlobalSearchResult';
import { EnvironmentResolveService } from '../environment-resolve/environment-resolve.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {
  constructor(
    private http: HttpClient,
    private erService: EnvironmentResolveService
  ) {}

  public getSearchResults(
    searchQuery: string,
    paging = DEFAULT_PAGING_CONFIG
  ): Observable<GlobalSearchResults> {
    const body = {
      application: 'Tinebase',
      method: 'searchGlobal',
      parameters: {
        filter: [
          { field: 'query', operator: 'contains', value: searchQuery },
          { field: 'creation_time', operator: 'within', value: 'anytime' }
        ],
        paging
      }
    };

    if (searchQuery) {
      return this.http.post(this.erService.environmentERS.apiUrl, body).pipe(
        map((response: ApiGlobalSearchResponse) => {
          const tickets: GlobalSearchResult[] = response.CPM_Model_Topic;
          const serviceCatalogItems: GlobalSearchResult[] =
            response.ServiceCatalog_Model_Item;
          const knowledgeModelItems: GlobalSearchResult[] =
            response.Knowledge_Model_Item;
          return <GlobalSearchResults>{
            tickets,
            serviceCatalogItems,
            knowledgeModelItems
          };
        })
      );
    } else {
      return of(<GlobalSearchResults>{
        tickets: [],
        serviceCatalogItems: [],
        knowledgeModelItems: []
      });
    }
  }
}
